import { ArrowLeft, CheckCircle, Monitor, Target, Award, BarChart3 } from 'lucide-react';

export default function AyniFormatPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-950 via-red-900 to-orange-900">
      {/* Header */}
      <div className="bg-white/10 backdrop-blur-xl border-b border-white/20">
        <div className="container mx-auto px-4 py-6">
          <button
            onClick={() => window.location.href = '/'}
            className="flex items-center gap-2 text-white hover:text-orange-300 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Ana Sayfaya Dön
          </button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Hero */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-orange-600 text-white px-8 py-4 rounded-full font-bold text-xl mb-6 shadow-2xl animate-pulse">
              <Monitor className="w-8 h-8" />
              <span>TRAFİKVERKET FORMATINDA</span>
            </div>
            <h1 className="text-7xl font-black text-white mb-6">
              Gerçek Sınav <span className="text-orange-400">Deneyimi!</span>
            </h1>
            <p className="text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              Sorularımız <strong className="text-orange-400">Trafikverket'in sınav sistemiyle birebir aynı</strong>. 
              Sınavdan önce tam olarak ne ile karşılaşacağınızı bileceksiniz!
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-4">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Aynı Soru Yapısı</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Her soru <strong>4 şıklı</strong>, <strong>tek doğru cevap</strong>, 
                tam olarak Trafikverket formatında. Sınavda aynı şeyi göreceksiniz!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mb-4">
                <BarChart3 className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Aynı Zorluk Seviyesi</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Sorularımızın <strong>zorluk dağılımı</strong> gerçek sınavla tamamen aynı. 
                Ne kolay ne zor - tam dengeli!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-2xl flex items-center justify-center mb-4">
                <Monitor className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Aynı Sınav Modu</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                <strong>70 soru</strong>, <strong>50 dakika</strong>, <strong>%70 başarı şartı</strong>. 
                Her şey gerçek sınav gibi!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mb-4">
                <Award className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-black text-white mb-4">Aynı Puanlama Sistemi</h3>
              <p className="text-white/80 text-lg leading-relaxed">
                Skor hesaplama ve performans analizi <strong>Trafikverket standartlarına uygun</strong>. 
                Gerçek notunuzu öğrenin!
              </p>
            </div>
          </div>

          {/* Why It Matters */}
          <div className="bg-gradient-to-br from-red-600 to-orange-700 rounded-3xl p-12 mb-12 shadow-2xl">
            <h2 className="text-4xl font-black text-white mb-6 text-center">
              Neden Bu Kadar Önemli? 🤔
            </h2>
            <div className="space-y-4 text-white text-xl leading-relaxed">
              <p className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <span>
                  Gerçek sınav formatına alışık olursanız, <strong>sınav günü stres yaşamazsınız</strong>
                </span>
              </p>
              <p className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <span>
                  Soru tipleri ve zorluk seviyesi aynı olunca, <strong>hazırlık daha etkili olur</strong>
                </span>
              </p>
              <p className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                <span>
                  Zaman yönetimini öğrenirsiniz - <strong>50 dakika nasıl kullanılır bilirsiniz</strong>
                </span>
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-cyan-600 to-blue-600 rounded-3xl p-12 text-center shadow-2xl">
            <h2 className="text-5xl font-black text-white mb-6">
              Gerçek Sınav Simülasyonuna Başla! 🎯
            </h2>
            <p className="text-2xl text-white/90 mb-8 leading-relaxed">
              Premium üyelikle <strong>sınırsız sınav denemesi</strong> yapın!
            </p>
            <button
              onClick={() => {
                // Ana sayfaya git ve login modal'ı aç
                window.location.href = '/?action=login';
              }}
              className="bg-white text-blue-600 px-12 py-6 rounded-2xl font-black text-2xl hover:scale-110 transition-all shadow-2xl"
            >
              💎 Premium'a Geç - Sınava Hazırlan!
            </button>
            <p className="text-white/80 mt-6 text-lg">
              ✅ Ücretsiz deneme • ✅ Anında başlangıç • ✅ Mobil uyumlu
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
